<template>
    <div>
          <div class="container-fluid">
            <div class="page-header">
              <div class="row">
                <div class="col-sm-6">
                  <h3>{{ $t("tenant_management") }}</h3>
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="index.html">{{$t("management")}}</a></li>
                    <li class="breadcrumb-item active">{{ $t("tenant_management") }}</li>
                  </ol>
                </div>
                <div class="col-sm-6">
                  <!-- Bookmark Start-->
                  <div class="bookmark">
                    <ul>
                      <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                      <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                      <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                      <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                      <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                        <form class="form-inline search-form">
                          <div class="form-group form-control-search">
                            <input type="text" :placeholder="$t('search') + '...'">
                          </div>
                        </form>
                      </li>
                    </ul>
                  </div>
                  <!-- Bookmark Ends-->
                </div>
              </div>
            </div>
          </div>
          <!-- Container-fluid starts-->
          <div class="container-fluid">
            <div class="row">
              <div class="col-6">
                <div class="card">
                  <div class="card-header pb-0">
                    <h5 v-if="editMode">{{$t("edit_tenant")}}</h5>
                    <h5 v-else>{{$t("create_tenant")}}</h5>
                  </div>
                  <div class="card-body">
                    <div class="form theme-form">
                      <div class="row">
                        <div class="col">
                          <div class="mb-3">
                            <label>{{$t("designation")}}</label>
                            <input class="form-control" type="text" v-model="tenant.name">
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <div class="mb-3">
                            <label>{{$t("street")}}</label>
                            <input class="form-control" type="text" v-model="tenant.street">
                          </div>
                        </div>
                        <div class="col">
                          <div class="mb-3">
                            <label>{{$t("number")}}</label>
                            <input class="form-control" type="text" v-model="tenant.hnr">
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col py-0">
                          <div class="mb-3">
                            <label>{{$t("zip")}}</label>
                            <input class="form-control" type="text" v-model="tenant.zip">
                          </div>
                        </div>
                        <div class="col py-0">
                          <div class="mb-3">
                            <label>{{$t("city")}}</label>
                            <input class="form-control" type="text" v-model="tenant.city">
                          </div>
                        </div>
                        <div class="col py-0">
                          <div class="mb-3">
                            <label>{{$t("country")}}</label>
                            <input class="form-control" type="text" v-model="tenant.country">
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <div class="mb-3">
                            <label>{{$t("taxNumber")}}</label>
                            <input class="form-control" type="text" v-model="tenant.taxNumber">
                          </div>
                          <div class="mb-3" v-show="$rights.includes('TENANT_INDEPENDENCE')">
                            <label>{{ $t("expert_status") }}</label>
                            <div>
                              <input type="checkbox" v-model="tenant.expert">
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="mb-3">
                            <label>{{$t("image")}}</label>
                            <Upload :label="''" v-model="tenant.picture" />
                          </div>
                        </div>
                      </div>
                    <button style="float: right;" @click="save()" class="btn btn-primary" type="button" data-bs-original-title="" title="">{{$t("save")}}</button>
                    <button class="btn btn-secondary mr-2" style="float: right;" @click="$routerBack()">{{$t("cancel")}}</button>
                  </div>
                </div>
              </div>
              </div>

              <div class="col-6">
                <div class="card">
                  <div class="card-header pb-0">
                    <h5>{{$t("connected_accounts")}}</h5>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">{{ $t("profile") }}</th>
                            <th scope="col">{{ $t("email") }}</th>
                            <th scope="col">{{ $t("actions") }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="accounts.length == 0">
                            <th colspan="3">{{ $t("no_entries") }}</th>
                          </tr>
                          <tr v-for="account in accounts" :key="account.id">
                            <td>{{account.userName}}</td>
                            <td>{{account.email}}</td>
                            <td>
                              <button class="btn btn-danger" @click="deleteAccount(account.id)"> <trash-icon size="16"></trash-icon></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br>
                    <button style="float: right;" @click="(showConnectPopup = true)" class="btn btn-primary" type="button" data-bs-original-title="" title="">{{ $t("add_account") }}</button>
                    <button style="float: right;" v-if="$rights.includes('TENANT_INDEPENDENCE')" @click="(showChargeAccountPopup = true)" class="btn btn-secondary mr-2" type="button" data-bs-original-title="" title="">{{ $t("charge_tenant_account") }}</button>
                    <div v-if="$rights.includes('TENANT_INDEPENDENCE')">
                      {{ $t("current_budget") }}: {{ budget }}€
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- Container-fluid Ends-->

          <!-- Add Account Modal -->
          <div class="modal fade show" v-show="showConnectPopup" tabindex="-1" aria-labelledby="exampleModalCenter" style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">{{ $t("add_account") }}</h5>
                  <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" data-bs-original-title="" title="" @click="(showConnectPopup = false)"></button>
                </div>
                <div class="modal-body">
                  <center><img class="img-fluid" src="/static/images/logo/logo.png" style="max-height: 100px" alt=""></center><br>
                  <div class="row">
                    <div class="col">
                      <div class="mb-3">
                        <label>{{ $t("email") }}</label>
                        <input class="form-control" type="text" @keypress.enter="addAccount()" placeholder="test@gmail.com" v-model="account.email">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="mb-3">
                        <label>{{ $t("password") }}</label>
                        <input class="form-control" type="password" @keypress.enter="addAccount()" placeholder="*********" v-model="account.password">
                      </div>
                    </div>
                </div>
                <div class="modal-footer">
                  <button @click="(showConnectPopup = false)" class="btn btn-secondary" type="button" data-bs-dismiss="modal" data-bs-original-title="" title="">{{ $t("cancel") }}</button>
                  <button @click="addAccount()" class="btn btn-primary" type="button" data-bs-original-title="" title="">{{ $t("add") }}</button>
                </div>
              </div>
            </div>
          </div>
          </div>

      <!-- Charge Account Modal -->
      <div class="modal fade show" v-show="showChargeAccountPopup" tabindex="-1" aria-labelledby="exampleModalCenter" style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t("charge_tenant_account") }}</h5>
              <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" data-bs-original-title="" title="" @click="(showChargeAccountPopup = false)"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col">
                  <div class="">
                    <label>{{ $t("amount") }}</label>
                    <div style="display: grid; grid-template-columns: 90% auto">
                      <input class="form-control" type="number" step="1" min="30" v-model="charge.amount">
                      <span style="margin: 0 auto;font-size: 22px;">€</span>
                    </div>
                  </div>
                </div>
              </div>
            <div class="modal-footer">
              <button @click="(showChargeAccountPopup = false)" class="btn btn-secondary" type="button" data-bs-dismiss="modal" data-bs-original-title="" title="">{{ $t("cancel") }}</button>
              <button @click="chargeTenantAccount()" class="btn btn-primary" type="button" data-bs-original-title="" title="">{{ $t("charge_tenant_account") }}</button>
            </div>
          </div>
        </div>
      </div>
      </div>
  
    </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import { MapPinIcon,PlusSquareIcon,TrashIcon, } from 'vue-feather-icons'

  export default {

    props: {
      tenantId: Number,
    },
    
    components: {
      apexcharts: VueApexCharts,
      MapPinIcon,
      PlusSquareIcon, 
      TrashIcon,
    },
    data() {
      return {
        editMode: false,
        showConnectPopup: false,
        showChargeAccountPopup: false,

        tenant: {
          name: "",
          street: "",
          hnr: "",
          zip: "",
          city: "",
          picture: "",
          country: "GERMANY",
          type: "company",
          taxNumber: "",
          population: 0,
          area: 0,
          expert: false,
          emailNotification: "",
          automaticReply: "",
          childrenTenantIds: [],
          etsAccounts: [],
        },

        budget: 0,

        tenants: [],
        accounts: [],

        account: {
          email: "",
          password: "",
        },
        oldTenant: null,

        charge: {
          amount: 0,
          tenantId: 0
        },

        map: {
          center: {
            latitude: 52.218945,
            longitude: 13.439067
          },
          zoom: 10,
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        },

        boundaries: [],
      };
    },
  
    mounted() {
      if (this.tenantId != null) {
        this.editMode = true;
        this.fetchEditingTenant();
        this.fetchAccounts();
        this.fetchTenantBudget();
      }else{
        this.fetchTenants();
      }
    },
  
    methods: {
      _validate(){
      
      if(this.tenant.name == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("name") }));
        return false;
      }
      if(this.tenant.street == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("street") }));
        return false;
      }
      if(this.tenant.hnr == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("hnr") }));
        return false;
      }
      if(this.tenant.zip == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("zip") }));
        return false;
      }
      if(this.tenant.city == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("city") }));
        return false;
      }
      if(this.tenant.country == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("country") }));
        return false;
      }
      if(this.tenant.taxNumber == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("taxNumber") }));
        return false;
      }
      console.log(this.tenant);
      return true;
    },
      fetchEditingTenant(){
        var _this = this;
        this.$axios
          .get("/api/tenant/" + this.tenantId)
          .then(function (response) {
            _this.tenant = response.data;
            _this.tenant.childrenTenantIds = [];
            if(_this.tenant.commune != null){
              _this.tenant.type = "commune";
              _this.map.center.latitude = _this.tenant.commune.latitude;
              _this.map.center.longitude = _this.tenant.commune.longitude;
              _this.boundaries = _this.tenant.commune.boundariesArray;
              _this.tenant.population = _this.tenant.commune.population;
              _this.tenant.area = _this.tenant.commune.area;
            }
            // Apply Children Information
            _this.tenants = _this.tenant.childrenTenants;
            _this.oldTenant = Object.assign({}, _this.tenant);
            for (let i = 0; i < _this.tenant.childrenTenants.length; i++) {
              const tenant = _this.tenant.childrenTenants[i];
              _this.tenant.childrenTenantIds.push(tenant.id);
            }
          })
          .catch(this.onError);
      },
      fetchTenants(search = ""){
        if(search == null) return;
        var _this = this;
        progressIndicator.hidden = false;
        this.$axios
          .get("/api/tenant?size=50&search=" + search)
          .then(function (response) {
            if(_this.tenants.length == 0) _this.tenants = response.data.content;
            for (let i = 0; i < response.data.content.length; i++) {
              const tenant = response.data.content[i];
              if(_this.tenants.filter(t => { return t.name == tenant.name }).length == 0){
                _this.tenants.push(tenant);
              }
            }

            if(_this.tenantId != null){
              // Remove Tenant which is being edited (no self-adding)
              for (let i = _this.tenants.length - 1; i >= 0; i--) {
                const tenant = _this.tenants[i];
                if(tenant.id == _this.tenantId){
                  _this.tenants.splice(i, 1);
                }
              }
            }
            _this.$forceUpdate();
          })
          .catch(this.onError)
          .finally(this.finalize);
      },
      save(){
        var tenant = Object.assign({}, this.tenant);
        if(this.editMode){
          this.updateTenant(tenant);
        }else{
          this.createTenant(tenant);
        }
      },
      addAccount(){
        var _this = this;
        if(this.account.email == "" || this.account.password == "") return;
        var account = Object.assign({}, this.account);
        this.$axios
          .post("/api/tenant/connect/ets", account)
          .then(function (response) {
            _this.account = {
              email: "",
              password: ""
            }
            _this.$noty.success(_this.$t("account_connected"));
            _this.showConnectPopup = false;
            _this.fetchAccounts();
          })
          .catch(e => {
            _this.$noty.error(e.response.data);
          });
      },
      deleteAccount(accountId){
        var _this = this;
        this.$axios
          .post("/api/tenant/disconnect/ets/" + accountId)
          .then(function (response) {
            _this.$noty.success(_this.$t("account_disconnected"));
            _this.fetchAccounts();
          })
          .catch(e => {
            _this.$noty.error(e.response.data);
          });
      },
      fetchAccounts(){
        var _this = this;
        this.$axios
          .get("/api/tenant/connect/ets")
          .then(function (response) {
            _this.accounts = response.data.content;
          })
          .catch(this.onError);
      },
      fetchTenantBudget(){
        var _this = this;
        if(this.tenantId == null) return;
        this.$axios
          .get("/api/purchase/budget/tenant/" + this.tenantId)
          .then(function (response) {
            var budget = response.data == null ? 0 : response.data;
            _this.budget = Math.round(budget * 100) / 100;
          })
          .catch(this.onError);
      },
      createTenant(tenant){
        var _this = this;
        this.$axios
          .post("/api/tenant", tenant)
          .then(function (response) {
            _this.$noty.success(_this.$t("tenant_saved"));
            _this.$router.push("/tenants");
          })
          .catch(this.onError);
      },
      updateTenant(tenant){
        var _this = this;
        this.$axios
          .put("/api/tenant/" + this.tenantId, tenant)
          .then(function (response) {
            _this.$noty.success(_this.$t("tenant_edited"));
            if(_this.oldTenant.name != _this.tenant.name || _this.oldTenant.picture != _this.tenant.picture){
              window.location.href = "/tenants";
            }else{
              _this.$router.push("/tenants");
            }
          })
          .catch(this.onError);
      },
      chargeTenantAccount(){
        var _this = this;
        this.charge.tenantId = this.tenantId;
        this.$axios
          .post("/api/purchase/charge/tenant", this.charge)
          .then(function (response) {
            _this.charge.amount = 0;
            _this.$noty.success(_this.$t("charged_tenant_account"));
            _this.$router.push("/tenants");
          })
          .catch(this.onError);
      },
      logError(error) {
        console.log(error);
      },
      onError(error) {
        console.log(error);
      },
      finalize(){
        progressIndicator.hidden = true;
      }
    },
  };
  </script>
  
  <style>
  </style>